export default {"productsSlider":"B0zvL","title":"TLl7g","more":"gTT91","header":"MnuZ3","products":"OaNl7","slideItem":"lBRss"};